<template>
  <div>
    <div
      v-if="currentStep != 7"
      class="flex h-28 items-center justify-between px-12"
    >
      <div class="flex">
        <img
          :src="require('/assets/images/small_mydid.png')"
          alt=""
          class="w-8 self-center mr-2"
        /><img
          :src="require('/assets/images//mydid-logo.png')"
          alt=""
          class="w-32 self-center"
        />
      </div>
      <div v-if="currentStep <= totalSteps" class="flex items-center gap-2">
        <p class="text-sm">{{ $t('signup.startupTxt') }}</p>
        <div class="relative w-12 h-12">
          <svg class="w-full h-full transform -rotate-90">
            <circle
              cx="24"
              cy="24"
              r="20"
              stroke="#4F46E5"
              stroke-opacity="0.2"
              stroke-width="4"
              fill="none"
            />
            <circle
              cx="24"
              cy="24"
              r="20"
              stroke="#4F46E5"
              stroke-width="4"
              fill="none"
              :stroke-dasharray="125.6"
              :stroke-dashoffset="
                125.6 - (125.6 * (currentStep - 1)) / (totalSteps - 1)
              "
              class="transition-all duration-300"
            />
          </svg>
          <div
            class="text-secondary absolute inset-0 flex items-center justify-center text-sm font-bold"
          >
            {{ currentStep }}/{{ totalSteps }}
          </div>
        </div>
      </div>

      <div class="">
        <router-link to="/signin">
          <button
            class="w-full text-sm text-center bg-secondary text-white shadow-sm rounded-lg cursor-pointer py-2 px-14"
            @click="sendEmailAuth"
          >
            {{ $t('signup.signinButton') }}
          </button>
        </router-link>
      </div>
    </div>
    <div class="flex justify-center mt-16">
      <div v-if="currentStep == 1">
        <p class="text-3xl text-center font-bold mb-2">
          {{ $t('signup.createCommunityTxt') }}
        </p>
        <p class="text-gray-500 text-center mb-12">
          {{ $t('signup.createCommunityBisTxt') }}
        </p>
        <div class="w-[600px] border shadow-md rounded-lg px-8 py-5">
          <p class="text-lg font-bold mb-5">
            {{ $t('signup.personalInfoSection') }}
          </p>
          <p class="text-sm mb-1.5">
            {{ $t('signup.lastNameTxt') }}
          </p>
          <div class="w-full mb-4 relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3">
              <icon name="user" class="fill-gray-500" />
            </div>
            <input
              type="text"
              :placeholder="$t('signup.lastNamePlaceholder')"
              class="w-full h-10 text-sm outline-none rounded-lg border border-gray-200 py-4 px-3 pl-10"
              v-model="contactLastName"
              maxlength="50"
            />
          </div>
          <p class="text-sm mb-1.5">
            {{ $t('signup.firstNameTxt') }}
          </p>
          <div class="w-full mb-4 relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3">
              <icon name="user" class="fill-gray-500" />
            </div>
            <input
              type="text"
              :placeholder="$t('signup.firstNamePlaceholder')"
              class="w-full h-10 text-sm outline-none rounded-lg border border-gray-200 py-4 px-3 pl-10"
              v-model="contactFirstName"
              maxlength="30"
            />
          </div>
          <p class="text-sm mb-1.5">
            {{ $t('signup.emailTxt') }}
          </p>
          <div class="w-full relative mb-5">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3">
              <icon name="mail" class="fill-gray-500" />
            </div>
            <input
              type="text"
              :placeholder="$t('signup.emailPlaceholder')"
              class="w-full h-10 text-sm outline-none rounded-lg border border-gray-200 py-4 px-3 pl-10"
              v-model="contactEmail"
              :class="{ 'pointer-events-none opacity-50': isWeb2Connexion }"
            />
          </div>
          <div class="w-full flex mb-5 gap-2">
            <input
              type="checkbox"
              class="w-4 h-4 rounded-sm border border-gray-200 outline-none cursor-pointer mt-0.5"
              v-model="termsAccepted"
            />
            <p class="text-start text-sm">
              {{ $t('signup.termsTxt1') }}
              <span class="text-secondary underline"
                ><a
                  href="https://mydid.com/legal/terms-us.html"
                  target="_blank"
                  >{{ $t('signup.termsTxt2') }}</a
                ></span
              >
              {{ $t('signup.termsTxt3') }}
              <span class="text-secondary underline"
                ><a
                  href="https://mydid.com/legal/privacy-us.html"
                  target="_blank"
                  >{{ $t('signup.termsTxt4') }}</a
                ></span
              >
              .
            </p>
          </div>
          <div class="w-full flex mb-12 gap-2">
            <input
              type="checkbox"
              class="w-4 h-4 rounded-sm border border-gray-200 outline-none cursor-pointer mt-0.5"
              v-model="contactOptIn"
            />
            <p class="text-start text-sm">
              {{ $t('signup.optInText') }}
            </p>
          </div>

          <div class="w-full mb-8">
            <button
              @click="validateStep(1) ? (currentStep = 2) : null"
              class="w-full h-10 bg-secondary text-sm text-white rounded-lg cursor-pointer"
            >
              {{ $t('signup.nextButton') }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="currentStep == 2">
        <p class="text-3xl text-center font-bold mb-2">
          {{ $t('signup.communityProfileTxt') }}
        </p>
        <p class="text-gray-500 text-center mb-12">
          {{ $t('signup.communityProfileTxtBis') }}
        </p>
        <div class="w-[600px] border shadow-md rounded-lg px-8 py-8">
          <div class="flex justify-center mb-10">
            <div class="relative">
              <img
                v-if="issuerPicturePreview"
                :src="issuerPicturePreview"
                alt="profile_picture"
                class="w-24 h-24 bg-gray-200 rounded-full"
              />
              <div
                @click="showImageHandler = true"
                class="absolute bottom-0 right-0 w-7 h-7 bg-gray-500 rounded-full cursor-pointer"
              >
                <icon name="edit" class="w-full fill-white pt-1.5 pb-0.5" />
              </div>
            </div>
          </div>
          <p class="text-sm text-center mb-1">
            <span class="font-bold">{{ $t('signup.uploadFileTxt') }}</span>
            {{ $t('signup.uploadFileTxtBis') }}
          </p>
          <p class="text-xs text-center">
            {{ $t('signup.uploadFileTxtTer') }}
          </p>
        </div>

        <div class="w-full mt-32">
          <button
            @click="validateStep(2) ? (currentStep = 3) : null"
            class="w-full h-10 bg-secondary text-sm text-white rounded-lg cursor-pointer mb-3"
          >
            {{ $t('signup.nextButton') }}
          </button>
          <button
            @click="currentStep = 1"
            class="w-full h-10 bg-gray-light text-sm text-secondary rounded-lg cursor-pointer"
          >
            {{ $t('signup.previousButton') }}
          </button>
        </div>
      </div>
      <div v-if="currentStep == 3">
        <p class="text-3xl text-center font-bold mb-2">
          {{ $t('signup.communityThemeTxt') }}
        </p>
        <p class="text-gray-500 text-center mb-12">
          {{ $t('signup.communityThemeTxtBis') }}
        </p>
        <div class="w-[600px] border shadow-md rounded-lg px-8 py-12">
          <div
            class="w-full aspect-[calc(4/1)] flex justify-center items-center bg-gray-light rounded-lg mb-5"
            :style="{ backgroundColor: issuerColor }"
          >
            <img
              v-if="issuerPicturePreview"
              :src="issuerPicturePreview"
              alt="profile_picture"
              class="w-[5rem] h-[5rem] bg-gray-200 rounded-full"
            />
          </div>
          <div class="w-full flex items-center gap-1">
            <div class="w-[6rem] border rounded-md px-2.5 py-1 mr-2">
              <p class="text-sm text-gray-500">{{ issuerColor }}</p>
            </div>
            <div
              @click="issuerColor = '#000000'"
              class="w-5 h-5 bg-[#000000] rounded-full cursor-pointer"
            ></div>
            <div
              @click="issuerColor = '#4723AD'"
              class="w-5 h-5 bg-[#4723AD] rounded-full cursor-pointer"
            ></div>
            <div
              @click="issuerColor = '#51CBFF'"
              class="w-5 h-5 bg-[#51CBFF] rounded-full cursor-pointer"
            ></div>
            <div class="relative"></div>
            <div
              @click="showColorPicker = !showColorPicker"
              click-outside-ignore-colorpicker
              class="w-5 h-5 flex items-center justify-center border border-gray-200 rounded-full cursor-pointer"
            >
              <icon name="plus" class="w-full fill-gray-500 p-0.5" />
            </div>
            <div v-if="showColorPicker" class="relative">
              <div
                class="absolute top-1 z-10 flex"
                v-click-outside="
                  () => {
                    showColorPicker = false;
                  }
                "
                click-outside-ignore-colorpicker-target
              >
                <ColorPicker
                  v-if="issuerColor"
                  theme="light"
                  :color="issuerColor"
                  :sucker-hide="true"
                  @changeColor="
                    (color) => {
                      issuerColor = color.hex;
                    }
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="w-full mt-32">
          <button
            @click="validateStep(3) ? (currentStep = 4) : null"
            class="w-full h-10 bg-secondary text-sm text-white rounded-lg cursor-pointer mb-3"
          >
            {{ $t('signup.nextButton') }}
          </button>
          <button
            @click="currentStep = 2"
            class="w-full h-10 bg-gray-light text-sm text-secondary rounded-lg cursor-pointer"
          >
            {{ $t('signup.previousButton') }}
          </button>
        </div>
      </div>
      <div v-if="currentStep == 4">
        <p class="text-3xl text-center font-bold mb-2">
          {{ $t('signup.communityDetailsTxt') }}
        </p>
        <p class="text-gray-500 text-center mb-12">
          {{ $t('signup.communityDetailsTxtBis') }}
        </p>
        <div class="w-[600px] border shadow-md rounded-lg px-8 py-8">
          <p class="text-sm font-bold mb-1.5">
            {{ $t('signup.nameTxt') }}
          </p>
          <div class="w-full mb-4 relative">
            <div class="absolute inset-y-0 right-0 flex items-center mr-4">
              <p class="text-sm text-gray-500">
                {{ 50 - (issuerName ? issuerName.length : 0) }}
              </p>
            </div>
            <input
              type="text"
              :placeholder="$t('signup.namePlaceholder')"
              class="w-full h-10 text-sm outline-none rounded-lg border border-gray-200 py-6 px-4 pr-10"
              v-model="issuerName"
              maxlength="50"
            />
          </div>
          <p class="text-sm font-bold mb-1.5">
            {{ $t('signup.descriptionTxt') }}
          </p>
          <div class="w-full mb-4 relative">
            <div class="absolute bottom-0 left-0 flex items-center p-5">
              <p class="text-sm text-gray-500">
                {{ 350 - (issuerDescription ? issuerDescription.length : 0) }}
              </p>
            </div>
            <textarea
              type="text"
              :placeholder="$t('signup.descriptionPlaceholder')"
              rows="5"
              class="w-full h-44 text-sm resize-none outline-none rounded-lg border border-gray-200 py-4 px-4 pb-10"
              v-model="issuerDescription"
              maxlength="1000"
            />
          </div>
          <p class="text-sm font-bold mb-1.5">
            {{ $t('signup.tagsTxt') }}
          </p>
          <div class="w-full mb-4 relative">
            <input
              type="text"
              :placeholder="$t('signup.tagsPlaceholder')"
              class="w-full h-10 text-sm outline-none rounded-lg border border-gray-200 py-6 px-4"
              v-model="tagQuery"
              @input="showTagPicker = true"
            />
            <div
              v-if="tagList.length > 0"
              class="w-fukk flex flex-wrap gap-1 mt-2.5"
              click-outside-ignore-tagpicker
            >
              <p
                v-for="tag in tagList"
                :key="tag"
                class="flex-none text-sm bg-blue-50 text-gray-500 rounded-md py-1 px-3"
              >
                {{ tag
                }}<icon
                  @click="
                    () => {
                      tagList.splice(tagList.indexOf(tag), 1);
                    }
                  "
                  name="cross"
                  class="fill-gray-700 w-3 h-3 pb-0.5 ml-2 cursor-pointer"
                />
              </p>
            </div>
            <div
              v-if="
                showTagPicker &&
                tagAutoComplete &&
                tagAutoComplete.filter((tag) => !tagList.includes(tag)).length >
                  0
              "
              class="relative"
              v-click-outside="
                () => {
                  showTagPicker = false;
                }
              "
              click-outside-ignore-tagpicker-target
            >
              <div
                class="absolute w-72 top-1 bg-white px-3 py-2 border rounded-xl shadow-md max-h-80 overflow-y-auto z-20"
              >
                <p
                  v-for="tag in tagAutoComplete.filter(
                    (tag) => !tagList.includes(tag)
                  )"
                  :key="tag"
                  @click="
                    () => {
                      tagList.push(tag);
                      tagQuery = '';
                      showTagPicker = false;
                    }
                  "
                  class="text-sm font-medium my-1 hover:bg-gray-light rounded-md cursor-pointer"
                >
                  {{ tag }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full mt-16">
          <button
            @click="validateStep(4) ? (currentStep = 5) : null"
            class="w-full h-10 bg-secondary text-sm text-white rounded-lg cursor-pointer mb-3"
          >
            {{ $t('signup.nextButton') }}
          </button>
          <button
            @click="currentStep = 3"
            class="w-full h-10 bg-gray-light text-sm text-secondary rounded-lg cursor-pointer"
          >
            {{ $t('signup.previousButton') }}
          </button>
        </div>
      </div>
      <div v-if="currentStep == 5">
        <p class="text-3xl text-center font-bold mb-2">
          {{ $t('signup.communityLinksTxt') }}
        </p>
        <p class="text-gray-500 text-center mb-12">
          {{ $t('signup.communityLinksTxtBis') }}
        </p>
        <div class="w-[600px] border shadow-md rounded-lg px-8 py-10">
          <div class="rounded-lg border border-gray-200 px-5 py-4 mb-7">
            <p class="text-sm font-bold mb-3.5">
              {{ $t('signup.messagingSection') }}
            </p>
            <div class="flex items-center gap-2.5 mb-2">
              <img
                :src="require('/assets/images/network_discord.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.discordPlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerDiscord"
              />
            </div>
            <div class="flex items-center gap-2.5">
              <img
                :src="require('/assets/images/network_telegram.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.telegramPlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerTelegram"
              />
            </div>
          </div>
          <div class="rounded-lg border border-gray-200 px-5 py-4 mb-7">
            <p class="text-sm font-bold mb-3.5">
              {{ $t('signup.socialSection') }}
            </p>
            <div class="flex items-center gap-2.5 mb-2">
              <img
                :src="require('/assets/images/network_x.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.twitterPlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerTwitter"
              />
            </div>
            <div class="flex items-center gap-2.5 mb-2">
              <img
                :src="require('/assets/images/network_instagram.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.instagramPlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerInstagram"
              />
            </div>
            <div class="flex items-center gap-2.5 mb-2">
              <img
                :src="require('/assets/images/network_facebook.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.facebookPlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerFacebook"
              />
            </div>
            <div class="flex items-center gap-2.5 mb-2">
              <img
                :src="require('/assets/images/network_linkedin.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.linkedinPlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerLinkedin"
              />
            </div>
            <div class="flex items-center gap-2.5">
              <img
                :src="require('/assets/images/network_youtube.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.youtubePlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerYoutube"
              />
            </div>
          </div>
          <div class="rounded-lg border border-gray-200 px-5 py-4">
            <p class="text-sm font-bold mb-3.5">
              {{ $t('signup.websiteSection') }}
            </p>
            <div class="flex items-center gap-2.5 mb-2">
              <img
                :src="require('/assets/images/network_website.png')"
                alt=""
                class="w-4"
              />
              <input
                type="text"
                :placeholder="$t('signup.websitePlaceholder')"
                class="w-full h-10 text-sm outline-none rounded-md border border-gray-200 py-4 px-3"
                v-model="issuerWebsite"
              />
            </div>
          </div>
        </div>
        <div class="w-full mt-16">
          <button
            @click="
              () => {
                if (validateStep(5)) {
                  currentStep = 6;
                  createIssuer();
                }
              }
            "
            class="w-full h-10 bg-secondary text-sm text-white rounded-lg cursor-pointer mb-3"
          >
            {{ $t('signup.nextButton') }}
          </button>
          <button
            @click="currentStep = 4"
            class="w-full h-10 bg-gray-light text-sm text-secondary rounded-lg cursor-pointer"
          >
            {{ $t('signup.previousButton') }}
          </button>
        </div>
      </div>
      <div v-if="currentStep == 6">
        <div class="flex justify-center mb-12">
          <Vue3Lottie
            :animationLink="require('/assets/images/loader-round.jpg')"
            :height="100"
            :width="100"
            :speed="1.5"
          />
        </div>
        <p
          v-if="waitingSignature && !isWeb2Connexion"
          class="text-3xl font-bold mb-12"
        >
          {{ $t('signup.checkAppTxt') }}
        </p>
      </div>
    </div>
  </div>
  <ImageHandler
    v-if="showImageHandler"
    :noGallery="true"
    @select="
      (file, data) => {
        issuerPicturePreview = data;
        issuerPictureFile = file;
        showImageHandler = false;
      }
    "
    @close="showImageHandler = false"
  ></ImageHandler>
</template>

<script>
import { ref, inject, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import ImageHandler from '../components/ImageHandler.vue';
import EventsBus from '../plugins/eventBus';
import blankProfileAvatar from '/assets/images/blank-profile-avatar.png';
import { ColorPicker } from 'vue-color-kit';
import jwt from 'jsonwebtoken';
import topics from '../../assets/interests.json';

export default {
  setup() {
    const api = inject('api');
    const utils = inject('utils');
    const cookies = inject('cookies');
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const { eventBus } = EventsBus();

    const currentAddress = computed(() => store.getters.getCurrentAddress);
    const currentPublicKeyBase58 = computed(
      () => store.getters.getCurrentPublicKeyBase58
    );
    const isWeb2Connexion = computed(() => store.getters.isWeb2Connexion);

    const currentStep = ref(1);
    const totalSteps = ref(5);

    const contactLastName = ref(null);
    const contactFirstName = ref(null);
    const contactEmail = ref(null);
    const contactOptIn = ref(false);

    const issuerPictureFile = ref(null);
    const issuerPictureMessage = ref(null);
    const issuerPicturePreview = ref(null);

    const issuerColor = ref('#9CA3AF');

    const issuerName = ref(null);
    const issuerSector = ref('');
    const issuerDescription = ref(null);

    const issuerDiscord = ref(null);
    const issuerTwitter = ref(null);
    const issuerTelegram = ref(null);
    const issuerInstagram = ref(null);
    const issuerFacebook = ref(null);
    const issuerLinkedin = ref(null);
    const issuerYoutube = ref(null);
    const issuerWebsite = ref(null);

    const tagList = ref(['Blockchain', 'Digital Marketing', 'Freedom']);
    const tagQuery = ref('');
    const tagAutoComplete = computed(() => {
      if (!tagQuery.value || tagQuery.value.length < 2) {
        return null;
      }
      return topics.filter((topic) =>
        topic.toLowerCase().includes(tagQuery.value.toLowerCase())
      );
    });
    const showTagPicker = ref(false);

    const issuerProfileIpfs = ref(null);
    const waitingSignature = ref(false);
    const showImageHandler = ref(false);
    const termsAccepted = ref(false);
    const showColorPicker = ref(false);

    if (!currentAddress.value) {
      router.push('/signin?new=1');
    }

    if (isWeb2Connexion.value) {
      const { connexionEmail, communityInfo } = jwt.decode(
        cookies.get('token_tmp')
      );
      if (connexionEmail) contactEmail.value = connexionEmail;
      if (communityInfo) {
        issuerName.value = communityInfo.name;
        contactLastName.value = communityInfo.lastName;
        contactFirstName.value = communityInfo.firstName;
      }
    }

    // handle default profile image
    fetch(blankProfileAvatar)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          const base64data = reader.result;
          issuerPictureFile.value = utils.base64ToFile(
            base64data,
            'blank-profile-avatar'
          );

          const reader2 = new FileReader();
          reader2.readAsDataURL(issuerPictureFile.value);
          reader2.onload = async (e) => {
            issuerPicturePreview.value = e.target.result;
          };
        };
      });

    function checkStep(step) {
      if (step == 1) {
        if (!contactLastName.value) throw t('signup.errors.lastNameMissing');
        if (contactLastName.value.length > 50)
          throw t('signup.errors.lastNameTooLong');

        if (!contactFirstName.value) throw t('signup.errors.firstNameMissing');
        if (contactFirstName.value.length > 30)
          throw t('signup.errors.firstNameTooLong');

        if (!contactEmail.value) throw t('signup.errors.emailMissing');

        const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        if (!emailRegex.test(contactEmail.value))
          throw t('signup.errors.emailNotValid');

        if (!termsAccepted.value) throw t('signup.errors.termsNotValid');

        return true;
      }
      if (step == 2) {
        if (!issuerPictureFile.value) throw t('signup.errors.pictureMissing');
      }
      if (step == 3) {
        const hexColorRegex = /^#[0-9A-Fa-f]{6}$/;
        if (!hexColorRegex.test(issuerColor.value))
          throw t('signup.errors.colorInvalid');
      }
      if (step == 4) {
        if (!issuerName.value) throw t('signup.errors.nameMissing');
        if (issuerName.value.length > 50 || issuerName.value.length < 3)
          throw t('signup.errors.nameTooLong');

        const issuerNameRegex =
          /[mM](\.| |-|_)?([yY](\.| |-|_)?)([dD](\.| |-|_)?)([iI](\.| |-|_)?)[dD]/;
        if (issuerNameRegex.test(issuerName.value))
          throw t('signup.errors.nameInvalid');

        // if (!issuerSector.value) throw t('signup.errors.sectorMissing');
        // if (issuerSector.value.length > 50 || issuerSector.value.length < 3)
        //   throw t('signup.errors.sectorTooLong');

        if (!issuerDescription.value)
          throw t('signup.errors.descriptionMissing');
        if (
          issuerDescription.value.length > 350 ||
          issuerDescription.value.length < 3
        )
          throw t('signup.errors.descriptionTooLong');

        if (tagList.value.length == 0) throw t('signup.errors.tagMissing');

        return true;
      }
      if (step == 5) {
        // const discordRegex =
        //   /^(https?:\/\/)?(www\.)?(discord\.(gg|io|me|li)|discordapp\.com\/invite)\/.+[a-z]$/;
        // if (issuerDiscord.value && !discordRegex.test(issuerDiscord.value))
        //   throw t('signup.errors.discordInvalid');

        // const telegramRegex =
        //   /^(https?:\/\/)?(www\.)?(t\.me|telegram\.me|telegram\.dog)\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)$/;
        // if (issuerTelegram.value && !telegramRegex.test(issuerTelegram.value))
        //   throw t('signup.errors.telegramInvalid');

        // const twitterRegex =
        //   /^(https?:\/\/)?(twitter|x).com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)$/;
        // if (issuerTwitter.value && !twitterRegex.test(issuerTwitter.value))
        //   throw t('signup.errors.twitterInvalid');

        // const instagramRegex =
        //   /^(https?:\/\/)?(www\.)?instagram\.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)$/;
        // if (
        //   issuerInstagram.value &&
        //   !instagramRegex.test(issuerInstagram.value)
        // )
        //   throw t('signup.errors.instagramInvalid');

        // const facebookRegex =
        //   /^(https?:\/\/)?(www\.)?facebook\.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)$/;
        // if (issuerFacebook.value && !facebookRegex.test(issuerFacebook.value))
        //   throw t('signup.errors.facebookInvalid');

        // const linkedinRegex =
        //   /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)$/;
        // if (issuerLinkedin.value && !linkedinRegex.test(issuerLinkedin.value))
        //   throw t('signup.errors.linkedinInvalid');

        // const youtubeRegex =
        //   /^(https?:\/\/)?(www\.)?youtube\.com\/channel\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)$/;
        // if (issuerYoutube.value && !youtubeRegex.test(issuerYoutube.value))
        //   throw t('signup.errors.youtubeInvalid');

        const websiteRegex =
          /^https:\/\/[a-zA-Z0-9-_.]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;
        if (issuerWebsite.value && !websiteRegex.test(issuerWebsite.value))
          throw t('signup.errors.websiteInvalid');

        return true;
      }
    }

    function validateStep(step) {
      try {
        checkStep(step);
      } catch (err) {
        utils.showToastMessageError(err);
        return false;
      }
      return true;
    }

    function deleteIssuerPictureInput() {
      issuerPictureFile.value = null;
      issuerPictureMessage.value = null;
      issuerPicturePreview.value = null;
    }

    async function createIssuer() {
      api
        .createIssuer(
          {
            did: 'did:mydid:' + currentPublicKeyBase58.value,
            name: issuerName.value,
            description: issuerDescription.value,
            sector: issuerSector.value,
            website: issuerWebsite.value,
            twitter: issuerTwitter.value,
            discord: issuerDiscord.value,
            telegram: issuerTelegram.value,
            instagram: issuerInstagram.value,
            facebook: issuerFacebook.value,
            linkedin: issuerLinkedin.value,
            youtube: issuerYoutube.value,
            bannerColor: issuerColor.value,
            tags: tagList.value,
            contactFirstName: contactFirstName.value,
            contactLastName: contactLastName.value,
            contactEmail: contactEmail.value,
            contactOptIn: contactOptIn.value,
          },
          issuerPictureFile.value
        )
        .then((res) => {
          const { callbackId } = res.data;

          api.waitOperationValidation(callbackId, (event) => {
            if (event.status == 'canceled') {
              waitingSignature.value = null;
            } else if (
              event.status == 'pending' ||
              event.status == 'treating'
            ) {
              const token = cookies.get('token_tmp');
              cookies.set('token', token);
              cookies.remove('token_tmp');
              window.location.href = '/';
            } else if (event.status == 'success') {
              // nothing because async
            } else if (event.status == 'error') {
              waitingSignature.value = null;
              utils.showToastMessageError(t('other.serverError'));
            }
          });
        })
        .catch(() => {
          utils.showToastMessageError(t('other.serverError'));
          waitingSignature.value = null;
        });
    }

    function onAddressConnected() {
      currentStep.value = 1;
    }

    return {
      currentAddress,
      currentPublicKeyBase58,
      issuerProfileIpfs,
      createIssuer,
      waitingSignature,
      isWeb2Connexion,

      currentStep,
      totalSteps,
      router,
      onAddressConnected,

      contactLastName,
      contactFirstName,
      contactEmail,
      contactOptIn,

      issuerPictureFile,
      issuerPictureMessage,
      issuerPicturePreview,
      deleteIssuerPictureInput,
      issuerName,
      issuerSector,
      issuerDescription,
      issuerColor,

      issuerDiscord,
      issuerTwitter,
      issuerTelegram,
      issuerInstagram,
      issuerFacebook,
      issuerLinkedin,
      issuerYoutube,
      issuerWebsite,

      showImageHandler,
      showColorPicker,
      showTagPicker,
      tagList,
      tagQuery,
      tagAutoComplete,
      termsAccepted,

      validateStep,
    };
  },
  components: {
    ImageHandler,
    ColorPicker,
  },
};
</script>
